<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M7.293 5.293a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L8 7.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4z"/></svg>